var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolutionFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M12.8386 6.52089V2.88424C13.2054 1.37941 10.6988 0 7.0307 0C3.36256 0 0.856003 1.31671 1.22282 2.88424H1.16162V6.9598C1.16162 7.0852 1.16168 7.2106 1.22282 7.2733C1.77304 8.84083 4.34073 10.0322 7.0307 10.0322C9.72066 10.0322 12.2884 8.84083 12.8386 7.2733C12.8997 7.0225 12.8997 6.7717 12.8386 6.52089Z",
    fill: "#D0D2D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M12.8996 2.06942C12.8385 2.06942 12.8384 2.06942 12.7773 2.06942C12.2271 0.9408 10.0262 0.0629883 7.0306 0.0629883C4.03495 0.0629883 1.83405 0.9408 1.28383 2.06942C1.2227 2.06942 1.10041 2.06942 1.03928 2.06942C0.489055 2.06942 0 2.38293 0 2.75913C0 3.13534 0.42792 3.44885 1.03928 3.44885C1.16155 3.44885 1.34492 3.44884 1.4672 3.38614C2.26196 4.76556 4.64629 5.70608 7.09172 5.70608C9.47601 5.70608 11.8603 4.76556 12.655 3.38614C12.7773 3.38614 12.8385 3.44885 12.9607 3.44885C13.5109 3.44885 14 3.13534 14 2.75913C13.9389 2.38293 13.4498 2.06942 12.8996 2.06942Z",
    fill: "#D0D2D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionFront);
export default __webpack_public_path__ + "static/media/solution-front.aa4bb7f52d665ac05b71925b40e4ef60.svg";
export { ForwardRef as ReactComponent };